
    import { Vue, Component, Inject } from 'vue-property-decorator'
    import { mapState } from 'vuex'
    import { ProductDefinitionMeta } from '@/app/product/entities/product-definition-meta.entity'
    import { ProductDefinition } from '@/app/product/entities/product-definition.entity'
    import { GetProductDefinitionsCommand } from '@/app/product/commands/get-product-definitions.command'
    import LanguageButton from '@/app/common/components/language-button.vue'
    import { License } from '@/app/license/entities/license.entity'
    import { GetMyUploadedDocumentsCommand } from '@/app/my-uploaded-documents/commands/get-my-uploaded-documents.command'

    @Component({
        components: { LanguageButton },
        computed: {
            ...mapState('product', ['definitions']),
            ...mapState('license', ['license'])
        }
    })
    export default class NavigationDrawerMenu extends Vue {
        drawer = false
        locale = this.$i18n.locale
        definitions!: ProductDefinition
        count = 0
        license!: License

        @Inject() getProductDefinitionsCommand!: GetProductDefinitionsCommand
        @Inject() getMyDocumentsCommand!: GetMyUploadedDocumentsCommand

        get documents() {
            return this.$store.state.myUploadedDocuments.documents
        }

        get hasLoaded() {
            return this.$store.state.myUploadedDocuments.hasLoaded
        }

        get showMyUploadedDocuments() {
            return !!(
                this.license &&
                this.license.features &&
                this.license.features.canViewUploadedDocuments &&
                this.hasLoaded &&
                this.documents &&
                this.documents.length > 0
            )
        }

        getTotal() {
            let total = 0

            if (this.definitions.appointment) {
                total += this.definitions.appointment.openActions
            }
            if (this.definitions.otd) {
                total += this.definitions.otd.openActions
            }
            if (this.definitions.cardifao) {
                total += this.definitions.cardifao.openActions
            }
            if (this.definitions.otd) {
                total += this.definitions.otd.openActions
            }
            if (this.definitions.fgv) {
                total += this.definitions.fgv.openActions
            }
            if (this.definitions.bankguarantee) {
                total += this.definitions.bankguarantee.openActions
            }
            if (this.definitions.businessIncome) {
                total += this.definitions.businessIncome.openActions
            }
            if (this.definitions.cardifao) {
                total += this.definitions.cardifao.openActions
            }
            if (this.definitions.credit) {
                total += this.definitions.credit.openActions
            }
            if (this.definitions.dossier) {
                total += this.definitions.dossier.openActions
            }
            if (this.definitions.generalInsurance) {
                total += this.definitions.generalInsurance.openActions
            }
            if (this.definitions.lifeInsurance) {
                total += this.definitions.lifeInsurance.openActions
            }
            if (this.definitions.mortgage) {
                total += this.definitions.mortgage.openActions
            }
            if (this.definitions.willWritingAdvice) {
                total += this.definitions.willWritingAdvice.openActions
            }
            if (this.definitions.purchaseIntention) {
                total += this.definitions.purchaseIntention.openActions
            }
            return total
        }

        async mounted() {
            if (!this.definitions) {
                await this.getProductDefinitionsCommand.run()
            }
            this.count = this.getTotal()

            if (!this.hasLoaded) {
                await this.getMyDocumentsCommand.run()
            }
        }

        buildRoute(definition: ProductDefinitionMeta, listRoute: string, detailRoute: string): object {
            if (definition.counter > 1) {
                return { name: listRoute }
            }
            return { name: detailRoute, params: { id: definition.firstProductId } }
        }
    }
